/** @jsx jsx */
import { jsx } from "theme-ui"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

import marks from "../../../images/marks"
import { ReactComponent as TwitterIcon } from "../../../images/icons/twitter.svg"
import { ReactComponent as InstagramIcon } from "../../../images/icons/instagram.svg"

const SocialPostThumbnail = ({
  imageUrl,
  to,
  subtitle,
  author,
  height,
  width,
  provider,
  children,
  preload,
}) => {
  let SocialTag
  const { i18n } = useTranslation()
  switch (provider) {
    case "Instagram":
      SocialTag = InstagramIcon
      break
    case "Twitter":
      SocialTag = TwitterIcon
      break
    default:
      SocialTag = null
  }

  return (
    <a
      href={to}
      sx={{
        position: "relative",
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
      target="_blank"
      rel="noopener noreferrer"
    >
      <img
        src={marks["mark5"]}
        alt=""
        aria-hidden
        sx={{
          position: "absolute",
          top: 2,
          [i18n.dir() === "rtl" ? "right" : "left"]: 2,
          width: "20%",
        }}
      />
      <div sx={{ backgroundColor: "#f9f9f9" }}>
        {imageUrl && (
          <div
            sx={{
              display: "block",
              backgroundSize: "cover",
              backgroundPosition: "center center",
              backgroundRepeat: "no-repeat",
              paddingBottom: `${(height / width) * 100}%`,
              width: "100%",
            }}
            style={{ backgroundImage: preload ? `url(${imageUrl})` : "" }}
          />
        )}
      </div>
      <span
        sx={{
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: "2",
          overflow: "hidden",
          fontSize: [1, 2],
          mt: 3,
        }}
      >
        {subtitle}
      </span>
      <span
        sx={{
          display: "flex",
          alignItems: "center",
          variant: "text.caps",
          whiteSpace: "nowrap",
          mt: 3,
        }}
      >
        {SocialTag && (
          <SocialTag
            height={14}
            width={14}
            alt="on Twitter by"
            sx={{
              mr: 1,
            }}
          />
        )}{" "}
        @ {author}
      </span>
      {children}
    </a>
  )
}

SocialPostThumbnail.propTypes = {
  image: PropTypes.object,
  to: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  preload: PropTypes.bool,
}

SocialPostThumbnail.defaultProps = {
  subtitle: null,
  preload: true,
}

export default SocialPostThumbnail
